PrestationValidator.$inject = ['validator'];

export default function PrestationValidator(validator) {
    const instance = new validator();

    return instance;
}
